{
    "coordinates": [
        39.80461883451309,
        -84.91026576197362
    ],
    "tooltip": "Whitewater",
    "title": "Whitewater Formation (Cincinnati Arch)",
    "country": "United States",
    "period": "Ordovician",
    "alt": "TODO"
}
